var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPlaySquare(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.10758 7.97111C8.10758 7.57337 8.10758 7.3745 8.1907 7.26348C8.26314 7.16673 8.37401 7.1062 8.49457 7.09759C8.6329 7.08771 8.80019 7.19524 9.13476 7.41032L13.0686 9.93921C13.3589 10.1258 13.5041 10.2192 13.5542 10.3378C13.598 10.4415 13.598 10.5585 13.5542 10.6622C13.5041 10.7808 13.3589 10.8742 13.0686 11.0608L9.13476 13.5897C8.80019 13.8048 8.6329 13.9123 8.49457 13.9024C8.37401 13.8938 8.26314 13.8333 8.1907 13.7365C8.10758 13.6255 8.10758 13.4266 8.10758 13.0289V7.97111Z",
    stroke: "white",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.69092 7C2.69092 5.59987 2.69092 4.8998 2.9634 4.36502C3.20309 3.89462 3.58554 3.51217 4.05594 3.27248C4.59072 3 5.29079 3 6.69092 3H13.6909C15.091 3 15.7911 3 16.3259 3.27248C16.7963 3.51217 17.1788 3.89462 17.4184 4.36502C17.6909 4.8998 17.6909 5.59987 17.6909 7V14C17.6909 15.4001 17.6909 16.1002 17.4184 16.635C17.1788 17.1054 16.7963 17.4878 16.3259 17.7275C15.7911 18 15.091 18 13.6909 18H6.69092C5.29079 18 4.59072 18 4.05594 17.7275C3.58554 17.4878 3.20309 17.1054 2.9634 16.635C2.69092 16.1002 2.69092 15.4001 2.69092 14V7Z",
    stroke: "white",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaySquare);
export default __webpack_public_path__ + "static/media/play-square.50a3f2244a6101e6e5b0a90b725898e5.svg";
export { ForwardRef as ReactComponent };